/**
 * @generated SignedSource<<8f8e6bff17c97922d5fdccd4453b1ac4>>
 * @relayHash 00de152e369f714ec9b678e593c3a3b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eac3ae0c1af4c562b2f8c4ef87c13e9380d10a9063b7f3c57dfc05d73706bb4a

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JQLBuilderWithAIFilterRefinementQuery$variables = {
  cloudId: string;
  isFilterRefinementEnabled: boolean;
};
export type JQLBuilderWithAIFilterRefinementQuery$data = {
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"FilterRefinement">;
  } | null | undefined;
};
export type JQLBuilderWithAIFilterRefinementQuery = {
  response: JQLBuilderWithAIFilterRefinementQuery$data;
  variables: JQLBuilderWithAIFilterRefinementQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isFilterRefinementEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "JQLBuilderWithAIFilterRefinementQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isFilterRefinementEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v1/*: any*/),
                "kind": "FragmentSpread",
                "name": "FilterRefinement"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JQLBuilderWithAIFilterRefinementQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isFilterRefinementEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v1/*: any*/),
                "concreteType": "JiraJqlBuilder",
                "kind": "LinkedField",
                "name": "jqlBuilder",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 100
                      },
                      {
                        "kind": "Literal",
                        "name": "jqlTerm",
                        "value": "assignee"
                      }
                    ],
                    "concreteType": "JiraJqlFieldValueConnection",
                    "kind": "LinkedField",
                    "name": "fieldValues",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraJqlFieldValueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "jqlTerm"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                      (v2/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "id"
                                      }
                                    ]
                                  }
                                ],
                                "type": "JiraJqlUserFieldValue"
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "fieldValues(first:100,jqlTerm:\"assignee\")"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "eac3ae0c1af4c562b2f8c4ef87c13e9380d10a9063b7f3c57dfc05d73706bb4a",
    "metadata": {},
    "name": "JQLBuilderWithAIFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0143d483589ea0ca8646e9717dc2ce36";

export default node;
